import UserAccount, { UserTenancy } from '../base/UserAccount'

export enum RoleLevel {
  None = 0,
  Read = 1,
  Write = 2,
  Delete = 3,
  SystemAdmin = 4
}

export enum Module {
  AssetManagement = 'ASSET_MGMT',
  Production = 'PRODUCTION',
  Measurements = 'MEASUREMENTS',
  FieldObservations = 'FIELD_OBSERVATIONS',
  AllocationsFormulas = 'ALLOCATIONS_FORMULAS',
  StateReports = 'STATE_REPORTS',
  CompanyAdmin = 'COMPANY_ADMIN'
}

const checkModuleAccess = (userTenantToCheck: UserTenancy, requiredModule: Module) => {
  const hasRequiredModuleAccess: boolean = Object.prototype.hasOwnProperty.call(userTenantToCheck.modules, requiredModule.valueOf())

  if (hasRequiredModuleAccess) {
    return getRoleFromModule(userTenantToCheck, requiredModule)
  } else {
    return RoleLevel.None
  }
}

const getRoleFromModule = (userTenantToCheck: UserTenancy, requiredModule: Module) => {
  const roles: object = userTenantToCheck.modules[requiredModule.valueOf()].roles

  if (Object.prototype.hasOwnProperty.call(roles, 'DELETE')) {
    return RoleLevel.Delete
  } else if (Object.prototype.hasOwnProperty.call(roles, 'WRITE')) {
    return RoleLevel.Write
  } else if (Object.prototype.hasOwnProperty.call(roles, 'READ')) {
    return RoleLevel.Read
  } else {
    return RoleLevel.None
  }
}

const authorize = (minimumRoleLevel: RoleLevel, requiredModule: Module | null, user: UserAccount | null, schemaName: string | null) => {
  let userRoleLevel: RoleLevel = RoleLevel.None

  if (user !== null) {
    if (user.systemAdmin) {
      userRoleLevel = RoleLevel.SystemAdmin
    } else if (requiredModule !== null) {
      userRoleLevel = checkModuleAccess(user.tenants[schemaName as string], requiredModule)
    }
  }

  return userRoleLevel.valueOf() >= minimumRoleLevel.valueOf()
}

const authorizeOneOf = (minimumRoleLevel: RoleLevel, oneOfModules: Module[], user: UserAccount, schemaName: string | null) => {
  for (const module of oneOfModules) {
    if (authorize(minimumRoleLevel, module as Module, user, schemaName)) return true
  }
  return false
}

export default {
  authorize,
  authorizeOneOf
}
